import { useSelector } from 'react-redux';

import _ from 'lodash';

import { languages } from '../providers/LanguageProvider';
import { Language } from '../resources/types';
import { selectLocale } from '../selectors';

export default function useCurrentLanguage(): Language {
  const locale = useSelector(selectLocale);

  // Extract language from locale. `es-US` -> `es`
  let language = locale && _.get(locale.match(/(\w+)-/), 1);

  // Ensure the language is supported
  if (!_.includes(languages, language)) {
    language = Language.English;
  }
  return language as Language;
}
